import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';

const initState = Map({
  customerTagTree: [],
  customerTagList: [],
  customerTagMap: {},

  convTagTree: [],
  convTagList: [],
  convTagMap: {},

  //
  callTag: []
});

export const {
  setCustomerTagTree,
  setCustomerTagList,
  setCustomerTagMap,
  setConvTagTree,
  setConvTagList,
  setConvTagMap,
  //
  setCallTags
} = createActions({
  setCustomerTagTree: action => action,
  setCustomerTagList: action => action,
  setCustomerTagMap: action => action,
  setConvTagTree: action => action,
  setConvTagList: action => action,
  setConvTagMap: action => action,
  //
  setCallTags: action => action
});

const tag = handleActions(
  {
    [setCustomerTagTree]: (state, action) => {
      const { payload } = action;
      return state.set('customerTagTree', payload || []);
    },
    [setCustomerTagList]: (state, action) => {
      const { payload } = action;
      return state.set('customerTagList', payload || []);
    },
    [setCustomerTagMap]: (state, action) => {
      return state.set('customerTagMap', action.payload || {});
    },
    [setConvTagTree]: (state, action) => {
      const { payload } = action;
      return state.set('convTagTree', payload || []);
    },
    [setConvTagList]: (state, action) => {
      const { payload } = action;
      return state.set('convTagList', payload || []);
    },
    [setConvTagMap]: (state, action) => {
      return state.set('convTagMap', action.payload || {});
    },

    //
    [setCallTags]: (state, action) => {
      const { payload } = action;
      const { call_tags = [] } = payload;
      return state.set('callTag', call_tags);
    }
  },
  initState
);

export default tag;
